import SectionHeading from "../../components/ui/SectionHeading";
import ServiceCard from "./ServiceCard";
import PageWrapper from "../../components/layout/PageWrapper";
import { servicesData } from "../../data/servicesData";

export default function Services() {
  return (
    <PageWrapper>
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading
            overline="Our Services"
            title="Premium solutions for your brand"
            subtitle="From events and social media to digital marketing, interior fit-out, and cross-industry expertise — we deliver with precision and style."
          />
          <div className="mt-16 md:mt-20 grid md:grid-cols-2 gap-8 md:gap-10">
            {servicesData.map((service, index) => (
              <ServiceCard key={service.id} service={service} index={index} />
            ))}
          </div>
        </div>
      </section>
    </PageWrapper>
  );
}
